    <template>
        <v-container fluid ma-3 pa-3>
            <v-layout row wrap justify-center>
                <v-flex>
                    <span class="style_title">Trend Management</span>
                    <br>
                    <br>
                    <div>
                        <span class="style_description" style="white-space: pre-line">In the "Trend Management" panel the approver can look and manage the trend list in a tabular view.
                         </span>
                      <br>
                      <v-img
                          max-width="800"
                          :src="require('@/assets/img/help/trend.png')"
                      >
                      </v-img>
                        <br>
                        <br>

                        <span class="style_paragraph" style="white-space: pre-line">Create new trend </span><br>
                        <span class="style_description" style="white-space: pre-line"> An approver can create a new trend, by clicking on the button "NEW TREND".
                          To fill correctly the fields, remember that:
                   <ul>
                       <li> Trend name is unique across all trends. </li>
                        <li> Tech Category: choose value from drop-down menu</li>
                        <li> Business Category: choose one or more categories from the drop down menu </li>
                        <li> Description: trend textual description. </li>
                        <li> AND clauses: write topics of which the trend is part. Max 5 combined And-Or clauses  </li>
                        <li> OR clauses: write topics of which the trend is part. Max 5 combined And-Or clauses </li>
                        <li> Adoption: choose a status from drop-down menu </li>
                        <li> Business Relevance: choose a relevance level from drop-down menu </li>
                        <li> Business Impact: choose an impact level from drop-down menu</li>

                   </ul>

                          <br>


    </span>
                        <span class="style_paragraph" style="white-space: pre-line">Search Trend</span><br>
                        <span class="style_description" style="white-space: pre-line"> Through the search text field you can write a query to obtain a trends list of interest.
    </span>
                      <br>
                      <br>
                      <span class="style_paragraph" style="white-space: pre-line">Edit and delete trend</span><br>
                      <span class="style_description" style="white-space: pre-line"> From the column actions you can edit and delete trends by clicking on the respective buttons.
    </span>


                    </div>
                    <br>


                </v-flex>
            </v-layout>
        </v-container>
    </template>

    <script>

        export default {
            name: "TrendManagementHelp",
            components: {},
            data() {
                return {

                }
            },

            methods: {

            }
        }
    </script>

    <style scoped>
        .style_description{
            font-size: 18px;
        }

        .style_paragraph{
            font-size: 22px;
            font-weight: bold;
        }

        .style_title{
            font-size: 34px;
            font-weight: bold;
        }

    </style>